import { compose } from 'redux'

import withErrorBoundary from 'components/shared/withErrorBoundary'
import withQueryResults from 'components/shared/withQueryResults'
import withParams from './withParams'
import withRedux from './withRedux'
import withQuery from './withQuery'
import withFormResults from 'components/shared/withFormResults'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'

// presentational component
import UI from './UI'

const withEditEmergencyContactForm = options => {
  const { redirect } = options

  const withEditEmergencyContactFormResults = withFormResults({
    mutation: 'updateEmergencyContact',
    field: 'emergencyContact',
    successMessage: 'Emergency contact updated',
    redirect
  })

  return compose(
    withErrorBoundary,
    withRedux,
    withQueryResults,
    withParams,
    withQuery,
    withEditEmergencyContactFormResults,
    withMutation,
    withEventHandlers
  )
}

// in account flow, redirect to emergency contacts list
export default withEditEmergencyContactForm({
  redirect: '/'
})(UI)

// for registration
export { withEditEmergencyContactForm }
